import React, { memo, useEffect, useState } from 'react';
import moment from 'moment';
import theme from './style';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { AppBar, Toolbar, Drawer, Tooltip, withWidth, Paper } from '@material-ui/core';
import DrawerMenu from '../../components/drawerMenu';
import Breadcrumbs from '../../components/breadcrumbs';
import { BorderSelect } from '../../components/inputs';
import { setLogOut, fetchUserData, setSelectedCustomer, setUserData } from '../../redux/actions/login';
import MenuIcon from '@material-ui/icons/Menu';
import { useHistory, useLocation } from 'react-router-dom';
import translate from '../../misc/applyTranslation';
import { fetchTranslations } from "../../redux/actions/settings";
import { useConfig } from "../../context/configContext";

import DashboardMobileHeaderActions from './DashboardMobileHeaderActions';
import DashboardDesktopHeaderActions from './DashboardDesktopHeaderActions';
import DashboardMobileNav from './DashboardMobileNav';

const TemplateDashboard = (props) => {
    const config = useConfig();
    const classes = theme(config);
    const location = useLocation();
    const history = useHistory();
    const {
        setLogOut,
        fetchUserData,
        children,
        width,
        userData,
        access_token,
        refresh_token,
        user_admin,
        connectedCustomers,
        selectedCustomer,
        setSelectedCustomer,
        fetchTranslations,
        setUserData
    } = props;
    let responsiveTest = (width === 'xs' || width === 'sm');

    const isCustomerMobile = responsiveTest && !user_admin;
    const [activeSheet, setActiveSheet] = useState(null); // 'invoices' | 'info' | null
    const [languageAnchorEl, setLanguageAnchorEl] = useState(null);
    const [profileAnchorEl, setProfileAnchorEl] = useState(null);

    const openLanguageMenu = (event) => setLanguageAnchorEl(event.currentTarget);
    const closeLanguageMenu = () => setLanguageAnchorEl(null);

    const openProfileMenu = (event) => setProfileAnchorEl(event.currentTarget);
    const closeProfileMenu = () => setProfileAnchorEl(null);

    const onLogoutClick = () => {
        closeProfileMenu();
        setLogOut({ user_admin });
    };

    const onLanguagePick = (params) => {
        closeLanguageMenu();
        handleLanguageChange(params);
    };

    const [open, setOpen] = useState(false)
    const [showLanguages, setShowLanguages] = useState(false);
    let urlArray = location.pathname.split("/");
    const handleMenuToggle = () => {
        setOpen(open ? false : true);
    }
    let drawerOpen = (!responsiveTest) || (responsiveTest && open)
    // const toggleUsertype = () => {
    //   setUserType();
    //   history.push('/en')
    // }
    const displayLanguages = () => {
        setShowLanguages(!showLanguages);
    }
    const handleLanguageChange = params => {
        urlArray[1] = params.lang;
        moment.locale(params.lang === 'se' ? 'sv' : 'en-gb');
        history.replace(urlArray.join("/"));
        fetchTranslations({ lang: params.code })
    }
    const handleChangeCustomer = customerId => {
        const customer = connectedCustomers.find(c => Number(c.id) === Number(customerId));
        setUserData(customer);
        setSelectedCustomer(customerId)
    }

    const goTo = (path) => {
        history.push(`/${urlArray[1]}${path}`);
    };

    const handleFooterNav = (value) => {
        setFooterValue(value);

        if (value === 'home') {
            goTo('');
            return;
        }
        if (value === 'contacts') {
            goTo('/contacts');
            return;
        }
        if (value === 'invoices') {
            setActiveSheet('invoices');
            return;
        }
        if (value === 'info') {
            setActiveSheet('info');
        }
    };

    const closeSheet = () => setActiveSheet(null);


    const getFooterValue = () => {
        const p = location.pathname;
        if (p.includes('/stel-invoices') || p.includes('/supplier-invoices')) return 'invoices';
        if (p.includes('/my-info') || p.includes('/general-info') || p.includes('/smart-usage') || p.includes('/usage')) return 'info';
        if (p.includes('/contacts')) return 'contacts';
        return 'home';
    };

    const [footerValue, setFooterValue] = useState(getFooterValue());

    useEffect(() => {
        setFooterValue(getFooterValue());
        // eslint-disable-next-line
    }, [location.pathname]);

    useEffect(() => {
        setActiveSheet(null);
    }, [location.pathname]);

    useEffect(() => {
        fetchUserData({
            access_token,
            refresh_token,
            admin: user_admin,
        })
        // eslint-disable-next-line
    }, [])
    return (
        <div className={classes.root}>
            <AppBar position="fixed" className={isCustomerMobile ? classes.appBarMobile : classes.appBar} elevation={0}>
                <Toolbar className={isCustomerMobile ? classes.appBarToolbarMobile : classes.appBarToolbar}>

                    {!responsiveTest &&
                        <div className={classes.appBarToolbarLogo} />
                    }
                    {responsiveTest &&
                        <div className={`${isCustomerMobile ? classes.responsiveMenuToolbarMobile : classes.responsiveMenuToolbar} ${open ? classes.menuOpen : ''}`}>
                            {!isCustomerMobile && (
                                <MenuIcon
                                    style={{ cursor: 'pointer', marginRight: 20, marginLeft: 10, fontSize: 30 }}
                                    onClick={handleMenuToggle}
                                />
                            )}
                            <div className={classes.appBarToolbarSmallLogo} />
                        </div>
                    }

                    <div className={isCustomerMobile ? classes.appBarToolbarUserMobile : classes.appBarToolbarUser}>
                        {!isCustomerMobile && !user_admin && connectedCustomers.length > 0 && (
                            <BorderSelect
                                onChange={(e) => handleChangeCustomer(e)}
                                selected={selectedCustomer}
                                items={connectedCustomers}
                            />
                        )}

                        {isCustomerMobile ? (
                            <>
                                <DashboardMobileHeaderActions
                                    userData={userData}
                                    urlArray={urlArray}
                                    classes={classes}
                                    openLanguageMenu={openLanguageMenu}
                                    closeLanguageMenu={closeLanguageMenu}
                                    languageAnchorEl={languageAnchorEl}
                                    onLanguagePick={onLanguagePick}
                                    openProfileMenu={openProfileMenu}
                                    closeProfileMenu={closeProfileMenu}
                                    profileAnchorEl={profileAnchorEl}
                                    onLogoutClick={onLogoutClick}
                                    translate={translate}
                                    headerUserIconPath={config.headerUserIconPath}
                                    headerTextColorMobile={config.headerTextColorMobile}
                                    headerArrowColorMobile={config.headerArrowColorMobile}
                                    connectedCustomers={connectedCustomers}
                                    selectedCustomer={selectedCustomer}
                                    onCustomerSwitch={handleChangeCustomer}
                                />
                            </>
                        ) : (
                            <>
                                <DashboardDesktopHeaderActions
                                    classes={classes}
                                    urlArray={urlArray}
                                    showLanguages={showLanguages}
                                    displayLanguages={displayLanguages}
                                    handleLanguageChange={handleLanguageChange}
                                    userData={userData}
                                    setLogOut={setLogOut}
                                    user_admin={user_admin}
                                    translate={translate}
                                />
                            </>
                        )}
                    </div>
                </Toolbar>
            </AppBar>

            {!isCustomerMobile && drawerOpen && (
                <Drawer
                    className={classes.drawer}
                    variant='permanent'
                    classes={{ paper: classes.drawerPaper }}
                >
                    <DrawerMenu closeMenu={() => setOpen(false)} isResponsive={responsiveTest} />
                </Drawer>
            )}

            <main className={isCustomerMobile ? `${classes.content} ${classes.contentWithFooter}` : classes.content}>
                <Breadcrumbs />
                {children}
            </main>

            {isCustomerMobile && (
                <DashboardMobileNav
                    classes={classes}
                    footerValue={footerValue}
                    handleFooterNav={handleFooterNav}
                    activeSheet={activeSheet}
                    closeSheet={closeSheet}
                    goTo={goTo}
                    translate={translate}
                    config={config}
                />
            )}
        </div>

    );
}
TemplateDashboard.propTypes = {
    setLogOut: PropTypes.func.isRequired,
    fetchUserData: PropTypes.func.isRequired,
}
const mapStateToProps = store => ({
    userData: store.login.userData,
    access_token: store.login.access_token,
    refresh_token: store.login.refresh_token,
    user_admin: store.login.user_admin,
    connectedCustomers: store.login.connectedCustomers,
    selectedCustomer: store.login.selectedCustomer,
});
const mapDispatchToProps = dispatch =>
    bindActionCreators({
        setLogOut,
        fetchUserData,
        setSelectedCustomer,
        fetchTranslations,
        setUserData
    }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(memo(withWidth()(TemplateDashboard)));
